import { tVariants } from '../../../style-system';

const rootStyles = tVariants({
    base: [
        'group/content',
        'min-h-full',
        'grid',
        'grid-cols-layout',
        '[&:has(.topnav,.topbar)]:grid-rows-[var(--navbar-height)_1fr]',
        '[&:has(.topnav):has(.topbar)]:grid-rows-[repeat(2,var(--navbar-height))_1fr]',
        'md:grid-rows-[var(--navbar-height)_1fr]',
        'md:[&:has(.topnav):has(.topbar)]:grid-rows-[repeat(2,var(--navbar-height))_1fr]',
        '[--content-offset:--navbar-height]',
        '[&:has(.topbar,.topnav)]:[--content-offset:calc(var(--navbar-height)*2)]',
        '[&:has(.topbar):has(.topnav)]:[--content-offset:calc(var(--navbar-height)*3)]',
        'md:[&:has(.topbar,.topnav)]:[--content-offset:calc(var(--navbar-height)*2)]',
        'md:[&:not(:has(.topbar)):has(.topnav)]:[--content-offset:--navbar-height]',
    ],
    variants: {
        collapsed: {
            true: 'xs:[--sidebar-width:5rem] md:[--sidebar-width:5rem]',
        },
    },
});

const topbarStyles = tVariants({
    base: [
        'topbar',
        'row-start-1 col-start-1 col-span-2 grid-row',
        'flex justify-between',
        'border-b h-[--navbar-height] max-h-[--navbar-height]',
        'bg-surface',
        'md:group-[&:has(.sidebar-full)]/content:col-start-2  md:group-[&:has(.sidebar-full)]/content:col-span-1',
    ],
});

const topnavStyles = tVariants({
    base: [
        'topnav',
        'row-start-1 group-[&:has(.topbar)]/content:row-start-2 col-start-1 col-span-2 grid-row',
        'flex items-center justify-between border-b h-[--navbar-height] max-h-[--navbar-height]',
        'bg-surface',
        'md:group-[&:has(.sidebar-full)]/content:col-start-2 md:group-[&:has(.sidebar-full)]/content:col-span-1',
    ],
    slots: {
        innerWrapper: 'w-full relative',
    },
    defaultVariants: {
        showOnAllBreakpoints: false,
    },
    variants: {
        showOnAllBreakpoints: { true: 'topnav-show-on-all-screens', false: 'md:hidden' },
    },
});

const sidebarStyles = tVariants({
    base: [
        'hidden',
        'md:flex',
        'flex-col',
        'sidebar',
        'group-[&:has(.topbar)]/content:[&:not(.sidebar-full)]:row-start-2',
        'group-[&:has(.topbar):has(.topnav)]/content:row-start-3',
        'row-span-2',
        'group-[&:has(.topbar)]/content:row-span-2',
        'col-start-1',
        'col-span-1',
        'min-w-[--sidebar-width]',
        'w-[--sidebar-width]',
        'border-r',
        'p-2',
        'min-h-full',
    ],
    variants: {
        fullHeight: { true: 'sidebar-full !row-start-1 !row-span-3' },
        noPaddingY: { true: 'py-0' },
    },
});

const containerStyles = tVariants({
    base: [
        'row-span-2',
        'group-[&:has(.topnav):has(.topbar)]/content:row-start-3',
        'group-[&:has(.topnav):has(.topnav-show-on-all-screens):has(.topbar)]/content:row-start-3',
        'md:group-[&:has(.topnav):has(.topbar)]/content:row-start-2',
        'md:group-[&:has(.topbar)]/content:row-start-2',
        'md:group-[&:has(.sidebar)]/content:col-start-2',
        'md:group-[&:has(.topnav):has(.topnav-show-on-all-screens):has(.topbar)]/content:row-start-3',
        'col-span-2 min-h-full',
    ],
    slots: {
        innerContainer: 'p-5',
    },
});

export { containerStyles, rootStyles, sidebarStyles, topbarStyles, topnavStyles };
